import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap";
import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

function CollapsibleComponent(props) {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const { t } = useTranslation(["styles", "translation"]);

  const [showCollapsibleBody, setShowCollapsibleBody] = useState(false);
  return (
    <Card className={styles.configuration1}>
      <Card.Header className={styles.configurationHeader2} onClick={() => setShowCollapsibleBody(!showCollapsibleBody)}>
        <div
          className={styles.inputValidationsHeaderDiv}
          style={translationStyles1 ? { textAlign: "right", marginRight: "10px" } : null }
        >
          <span>{t(`translation:${props.heading}`)}</span>
          {showCollapsibleBody === true ? (
            <FontAwesomeIcon
              className={styles.downArrow}
              icon={faAngleUp}
              style={translationStyles1 ? { float: "left" } : {width: "10px"}}
            />
          ) : (
            <FontAwesomeIcon
              className={styles.downArrow}
              icon={faAngleDown}
              style={translationStyles1 ? { float: "left" } : {width: "10px"}}
            />
          )}
        </div>
      </Card.Header>
      {showCollapsibleBody === true ? (
        <Card.Body
          className={
            props.leftBody && props.leftBody.length === 0 ? styles.emptyCardBody : styles.backdropCollapsibleBody
          }
          style={translationStyles1 && props.heading !== "Options" ? { display: "flex" } : null}
        >
          {props.leftBody && (
            <div style={{marginTop: "5px"}} className={styles.collapsibleLeftBody}>
              {props.leftBody.map((item) => {
                return item;
              })}
            </div>
          )}
          {props.rightBody && (
            <div style={{marginTop: "5px"}} className={styles.collapsibleRightBody}>
              {props.rightBody.map((item) => {
                return item;
              })}
            </div>
          )}

          {props.fullBody && (
            <>
              {props.fullBody.map((item) => {
                //console.log(item);
                return item;
              })}
            </>
          )}
        </Card.Body>
      ) : null}
    </Card>
  );
}

export default CollapsibleComponent;
